// src/components/testpage/ConfigControls.jsx
import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import { Save as SaveIcon, Restore as RestoreIcon, SettingsBackupRestore as PresetsIcon } from '@mui/icons-material';

const ConfigControls = ({
  onLoadPreset,
  onSaveConfig,    // Saves to localStorage
  onResetConfig,   // Resets to initialLiveConfig and clears localStorage
  widgetLoaded,    // To disable controls if widget not loaded for live updates
}) => {
  const presets = [
    { name: 'Default Minimal', id: 'default_minimal' }, // Changed presets to be more generic
    { name: 'Bright & Friendly', id: 'bright_friendly' },
    { name: 'Dark Mode (Basic)', id: 'dark_basic' },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" fontWeight="500" gutterBottom>
        Configuration Presets & Local Persistence
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }} flexWrap="wrap">
        {presets.map((preset) => (
          <Button
            key={preset.id}
            variant="outlined"
            onClick={() => onLoadPreset(preset.id)}
            // Presets can be loaded even if widget not live, to populate the panel
            size="small"
            startIcon={<PresetsIcon />}
          >
            Load: {preset.name}
          </Button>
        ))}
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} flexWrap="wrap">
        <Button
          variant="outlined"
          color="primary"
          onClick={onSaveConfig}
          // Saving to localStorage can be done even if widget not live
          startIcon={<SaveIcon />}
          size="small"
        >
          Save Panel to Browser
        </Button>
        <Button
          variant="outlined"
          color="warning" // Changed to warning for reset
          onClick={onResetConfig}
          // Resetting can be done even if widget not live
          startIcon={<RestoreIcon />}
          size="small"
        >
          Reset Panel to Defaults
        </Button>
      </Stack>
      <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
        "Save Panel" saves the current settings in this panel to your browser's local storage for this page. It does not affect the database.
      </Typography>
    </Box>
  );
};

export default ConfigControls;